import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { delay, takeUntil } from 'rxjs/operators';
import { Subject,forkJoin } from 'rxjs';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { RolesControlService } from '../../../../../services/roles-control.service';
import { PermissionsService } from '../../../../../services/permissions.service';
import { RoleModel } from '../models/roles.model';


@Component({
  selector: 'app-create-edit-roles-controller',
  templateUrl: './create-edit-roles-controller.component.html',
  styleUrls: ['./create-edit-roles-controller.component.scss']
})
export class CreateEditRolesControllerComponent implements OnInit {
	@Input() data: any = {};
	formGroup: RxFormGroup;
	isEdit = false;
  fields: any = {
		name: {
			type: 'input',
			options: {
				path: 'name',
				class: 'col-sm-12',
				label: {
					text: 'Nombre',
					class: 'col-sm-12'
				}
			}
		},
		permissions: {
			type: 'multiselect',
			options: {
				path: 'permissions',
				class: 'col-sm-12',
				label: {
					text: 'Permisos',
					class: 'col-sm-12'
				},
				options: [],
				optionLabel: 'name',
				optionValue: 'id',
				multiple: true
			}
		}
	};
	private atComponentDestroy = new Subject();

  constructor(
    private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
    private rolesControlService: RolesControlService,
    private permissionsService: PermissionsService
  ) {
    this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(form => {
			this.formGroup = form;
			this.cdr.detectChanges();
		});
  }

	async ngOnInit(): Promise<void> {
    this.formService.transformIntoFormGroup(RoleModel, this.data);

    let PermissionResponse = await this.permissionsService.getAll();
    let permissions = PermissionResponse.data??[];
    permissions = permissions.map(p => ({
      id: p.id,
      name: `${p.name}`
    }));
    
    this.fields.permissions.options.options = [...permissions];
    if (this.data?.id&& Array.isArray(this.data.permissions)) {
      const selectedpermissionsIds = this.data.permissions.map(p => typeof p === 'object' ? p.id : p);
			this.formGroup.get('permissions')?.setValue(selectedpermissionsIds);
		}
    if(this.data?.id) {
      this.isEdit = true;
      this.formGroup.get('name').setValue(this.data.name);
    }
		this.formGroup.valueChanges
		.pipe(takeUntil(this.atComponentDestroy))
		.subscribe(data => {
		  this.cdr.markForCheck();
		});
  }
  submit(): void {
		this.rolesControlService.createOrUpdate(this.formGroup, this.data?.id)
		  .pipe(takeUntil(this.atComponentDestroy))
		  .subscribe(data => {
			this.broadcast.reloadDataTable();
			this.modalRef.hide();
		  }, error => {
			console.error("Error al enviar los datos:", error);
		  });
	  }

	/**
	 * Transform and object into an array
	 * @param enumme
	 * @returns
	 */
	toArray(enumme): any[] {
		return Object.keys(enumme)
			.map(key => ({ id: key, name: enumme[key] }));
	}

}
